// IPFS gateways to try in order
const IPFS_GATEWAYS = [
  'https://ipfs.io/ipfs/',
  'https://gateway.pinata.cloud/ipfs/',
  'https://cloudflare-ipfs.com/ipfs/',
];

const PUDGY_PENGUINS = {
  imageCID: 'QmNf1UsmdGaMbpatQ6toXSkzDpizaGmC9zfunCyoz1enD5',
  metadataCID: 'QmWXJXRdExse2YHRY21Wvh4pjRxNRQcWVhcKw4DLVnqGqs',
};

// Function to get IPFS URL with fallback gateways
export const getIPFSUrl = async (cid, path = '') => {
  for (const gateway of IPFS_GATEWAYS) {
    try {
      const url = `${gateway}${cid}${path}`;
      const response = await fetch(url, { method: 'HEAD' });
      if (response.ok) {
        return url;
      }
    } catch (error) {
      console.warn(`Gateway ${gateway} failed, trying next...`);
    }
  }
  throw new Error('All IPFS gateways failed');
};

// Get Pudgy Penguin image URL by token ID
export const getPudgyPenguinImage = async (tokenId) => {
  try {
    return await getIPFSUrl(PUDGY_PENGUINS.imageCID, `/${tokenId}.png`);
  } catch (error) {
    console.error(`Failed to get Pudgy Penguin image for token ${tokenId}:`, error);
    return null;
  }
};

// Get random token IDs for Pudgy Penguins
export const getRandomPudgyTokenIds = (count = 12) => {
  const ids = new Set();
  while (ids.size < count) {
    ids.add(Math.floor(Math.random() * 8888) + 1);
  }
  return Array.from(ids);
};
